/*
 * @Author: your name
 * @Date: 2020-07-09 00:46:22
 * @LastEditTime: 2020-07-09 22:00:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edite
 * @FilePath: \vue-cli4-framwork\src\main.js
 */
import Vue from 'vue'
import VCharts from 'v-charts'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
//import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/default/theme/index.css'
import '@/assets/iconfont.css'
import '@/assets/css/style.css'
import VueCookies from 'vue-cookies';
import VueWechatTitle from 'vue-wechat-title'; //统一标题
import dayjs from 'dayjs'
/**
 * 引入axios，并将axios注入到vue
 */
// import './service'
import axios from 'axios'
import { Loading } from 'element-ui'

let loadingInstance = null
let requestCount = 0 // 请求计数器

axios.defaults.baseURL = 'https://www.biaozhuncha.com/api'
axios.defaults.withCredentials=true;//让ajax携带cookie
Vue.prototype.$axios = axios
/**
 * 引入全局序列号Qs * 
 */
import Qs from 'qs';


Vue.prototype.$qs = Qs;
Vue.use(VueCookies);
Vue.use(ElementUI)
Vue.use(VCharts)
Vue.use(VueWechatTitle);
Vue.config.productionTip = false
// 正式环境清除所有console.log
if (process.env.NODE_ENV === 'production') {
  if (window) {
    window.console.log = function () {};
  }
}
// 请求拦截器
// axios.interceptors.request.use(config => {
//   if (requestCount === 0) {
//     loadingInstance = Loading.service({
//       lock: true,
//       text: '数据加载中...',
//       background: 'rgba(0, 0, 0, 0.7)'
//     })
//   }
//   requestCount++
//   return config
// })

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  // requestCount--
  // if (requestCount === 0) {
  //   loadingInstance.close()
  // }
  if (response.data.status === 404 ) {
    router.push('/404')
  }
  return response;
}, function (error) {
  // requestCount = Math.max(requestCount - 1, 0)
  // if (requestCount === 0) {
  //   loadingInstance.close()
  // }

  // 对响应错误做点什么，例如统一处理错误信息
  if (error.response && error.response.status === 401) { // 假设401状态码表示未授权，即token无效或过期
    router.push('/'); // 重定向到登录页面
  }
  return Promise.reject(error);
});


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')